import { cn } from "@/lib/utils";

/**
 * The product's name, in one place. "Leaderboard" is a working name: a new
 * one is coming (Tiago, 10 October), and the mark beside it is a stand-in
 * until it does. index.html's <title> and the api's emails carry it too.
 */
export const APP_NAME = "Leaderboard";

/**
 * The tab's title: the page, most specific first, then the app's name —
 * "Members · Northside Barbell — Leaderboard" (decided with Tiago 12
 * October), so a narrow tab still shows what differs. React hoists it into
 * the head, where it takes over index.html's, so every page renders one: a
 * page without leaves the tab blank.
 */
export function PageTitle({ of }: { of: (string | null | undefined)[] }) {
  return <title>{`${of.filter(Boolean).join(" · ")} — ${APP_NAME}`}</title>;
}

/**
 * The mark and the name, as the signed-out header shows them, or — `title` —
 * as the top of Home does, the name as large as any page's title.
 */
export function Wordmark({ title = false, className }: { title?: boolean; className?: string }) {
  return (
    <span className={cn("flex items-center", title ? "gap-3" : "gap-2.5", className)}>
      <span
        aria-hidden="true"
        className={cn(
          "flex items-center justify-center bg-primary text-primary-foreground",
          title ? "size-9 rounded-xl" : "size-8 rounded-lg",
        )}
      >
        <svg viewBox="0 0 24 24" width={title ? 20 : 18} height={title ? 20 : 18} fill="currentColor">
          <rect x="3" y="11" width="5" height="9" rx="1" />
          <rect x="9.5" y="5" width="5" height="15" rx="1" />
          <rect x="16" y="14" width="5" height="6" rx="1" />
        </svg>
      </span>
      <span className={title ? "page-title" : "font-heading text-xl font-semibold tracking-tight"}>{APP_NAME}</span>
    </span>
  );
}
